import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from './types';

export interface GeneralResponse {
    totalCount: any;
    count: any;
    totalPages: any;
    limit: any;
    page: any;
    data: GeneralResponseBody;
}
export interface CommunicatorMessageType {
    id: string;
    code: string;
}
export interface GeneralResponseBody {
    data: Array<CommunicatorMessageType>;
    limit: number;
    message: string;
    page: number;
    totalCount: number;
    totalPages: number;
    warnings: Array<string>;
    count: number;
}

export interface CommunicatorMessagePayload {
    attachments?: Array<string>;
    claimApplicationId?: string;
    content?: string;
    visibleToAragOnly?: boolean;
    messageId?: string;
}
export const fetchCommunicatorMessage = createAction<
    fetchCommunicatorMessageAction | string
>(ActionTypes.FETCH_COMMUNICATOR_MESSAGE);
export const fetchCommunicatorMessageSuccess =
    createAction<fetchCommunicatorMessageSuccessAction>(
        ActionTypes.FETCH_COMMUNICATOR_MESSAGE_SUCCESS,
    );
export const fetchCommunicatorMessageFailed =
    createAction<fetchCommunicatorMessageFailedAction>(
        ActionTypes.FETCH_COMMUNICATOR_MESSAGE_FAILED,
    );
export const createCommunicatorMessage =
    createAction<createCommunicatorMessageAction>(
        ActionTypes.CREATE_COMMUNICATOR_MESSAGE,
    );
export const createCommunicatorMessageSuccess =
    createAction<createCommunicatorMessageSuccessAction>(
        ActionTypes.CREATE_COMMUNICATOR_MESSAGE_SUCCESS,
    );
export const createCommunicatorMessageFailed =
    createAction<createCommunicatorMessageFailedAction>(
        ActionTypes.CREATE_COMMUNICATOR_MESSAGE_FAILED,
    );
export const fetchCommunicatorHistory =
    createAction<fetchCommunicatorHistoryAction>(
        ActionTypes.FETCH_COMMUNICATOR_HISTORY,
    );
export const fetchCommunicatorHistorySuccess =
    createAction<fetchCommunicatorHistorySuccessAction>(
        ActionTypes.FETCH_COMMUNICATOR_HISTORY_SUCCESS,
    );
export const fetchCommunicatorHistoryFailed =
    createAction<fetchCommunicatorHistoryFailedAction>(
        ActionTypes.FETCH_COMMUNICATOR_HISTORY_FAILED,
    );

export interface fetchCommunicatorMessageAction {
    type: typeof ActionTypes.FETCH_COMMUNICATOR_MESSAGE;
    payload: CommunicatorMessagePayload;
}

export interface fetchCommunicatorMessageSuccessAction {
    type: typeof ActionTypes.FETCH_COMMUNICATOR_MESSAGE_SUCCESS;
    body: GeneralResponse;
}

export interface fetchCommunicatorMessageFailedAction {
    type: typeof ActionTypes.FETCH_COMMUNICATOR_MESSAGE_FAILED;
    payload: GeneralResponse;
}

export interface createCommunicatorMessageAction {
    type?: typeof ActionTypes.CREATE_COMMUNICATOR_MESSAGE;
    content: string;
    claimApplicationId: string;
    attachments: Array<{ id: string }>;
}

export interface createCommunicatorMessageSuccessAction {
    type: typeof ActionTypes.CREATE_COMMUNICATOR_MESSAGE_SUCCESS;
    payload: GeneralResponse;
}

export interface createCommunicatorMessageFailedAction {
    type: typeof ActionTypes.CREATE_COMMUNICATOR_MESSAGE_FAILED;
    payload: GeneralResponse;
}

export interface fetchCommunicatorHistoryAction {
    type?: typeof ActionTypes.FETCH_COMMUNICATOR_HISTORY;
    claimApplicationId: string;
    filters: {
        page: number;
        limit: number;
    };
}

export interface fetchCommunicatorHistorySuccessAction {
    type: typeof ActionTypes.FETCH_COMMUNICATOR_HISTORY_SUCCESS;
    body: GeneralResponse;
}
export interface fetchCommunicatorHistoryFailedAction {
    type: typeof ActionTypes.FETCH_COMMUNICATOR_HISTORY_FAILED;
    payload: GeneralResponse;
}
